'use strict';

var getValues = require('../helpers/values');

module.exports = function values() {
  return new this.constructor(getValues(this.items));
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/values.js
// module id = 1739
// module chunks = 2